// removed by extract-text-webpack-plugin
module.exports = {"body":"RIF_63WTuHU-Gui9eDrdb","intro":"_1xmCB86yamJxby1fAfAtmY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/body/body.css
// module id = 22
// module chunks = 0